export enum TabName {
  ASSIGNEES = 'ASSIGNEES',
  ROLES = 'ROLES',
  INDIVIDUAL = 'INDIVIDUAL',
}

export enum PanelTitle {
  ACTIVITY = 'activity',
  ADVANCEMENT = 'advancement',
  CALENDAR = 'calendar',
  FINANCE = 'finance',
  LEADERSHIP = 'leadership',
  MEMBERSHIP = 'membership',
  MESSAGING = 'messaging',
  UNIT = 'unit',
}

export enum CelKey {
  ACTIVITY_CREATE = 'activityCreate',
  ADVANCEMENT_AWARD = 'advancementAward',
  ADVANCEMENT_APROVE = 'advancementApprove',
  ADVANCEMENT_EDIT = 'advancementEdit',
  ADVANCEMENT_MBLIST = 'advancementMbList',
  ADVANCEMENT_SCOUT_EDITOR = 'advancementScoutEditor',
  ADVANCEMENT_TENDERFOOT_EDITOR = 'advancementTenderfootEditor',
  ADVANCEMENT_SECONDCLASS_EDITOR = 'advancementSecondClassEditor',
  ADVANCEMENT_FIRSTCLASS_EDITOR = 'advancementFirstClassEditorEditor',
  CALENDAR_CREATE = 'calendarCreate',
  FINANCE_CREATE = 'financeCreate',
  FINANCE_INDIVCREATE = 'financeIndivCreate',
  FINANCE_POCREATE = 'financePoCreate',
  LEADERSHIP_ACCEPTANCE = 'leadershipAcceptance',
  LEADERSHIP_APPROVE = 'leadershipApprove',
  MEMBERSHIP_INACTIVE_YOUTH = 'membershipInactiveYouth',
  MEMBERSHIP_INACTIVE_ADULT = 'membershipInactiveAdult',
  MESSAGING_CREATE = 'messagingCreate',
  MESSAGING_GROPU_CREATE = 'messagingGroupCreate',
  UNIT_PROFILE_EDIT = 'unitProfileEdit',
  UNIT_EDIT = 'unitEdit',
  UNIT_REPORTS = 'unitReports',
  SUBUNIT_CREATE = 'subUnitCreate',
  SUBUNIT_EDIT = 'subUnitEdit',
  SUBUNIT_DENCHIEF_ADD = 'subUnitDenchiefAdd',
}

export enum PositionsId {
  //ket 3 positions-----------
  CM = 465, //Cubmaster
  CR = 466, //Chartered Organization Rep.
  CC = 464, //Committee Chair
  SM = 482, //Scoutmaster
  CUR = 776, //Council Unit Representative
  VCA = 476, //Venturing Crew Advisor
  SR = 481, //Skipper
  //-----------------------------
  MC = 472, //Committee Member
  NM = 671, //New Member Coordinator
  PT = 478, //Pack Trainer
  K3D = 576, //Key 3 Delegate
  CORD = 747, //COR Delegate
  // US = , //Unit Support
  // SUS = , //Sub-Unit Support
  // DS = , //Den Support
  DL = 469, //Den Leader
}

export enum UnitSupportPositionIds {
  UT = 35, //Unit Treasurer
}

export enum SubUnitSupportPositionIds {
  ADL = 467, //Asst. Den Leader
}

export const PositionsAllowedToHaveCR = [
  PositionsId.CC,
  PositionsId.MC,
  PositionsId.NM,
  PositionsId.PT,
];

export const PositionsProhibitedUnitSupport = [
  PositionsId.CM,
  PositionsId.CR,
  PositionsId.CC,
  PositionsId.SM,
  PositionsId.K3D,
  PositionsId.CORD,
  PositionsId.CUR,
  PositionsId.VCA,
  PositionsId.SR,
];

export const PositionsProhibitedSubUnitSupport = [
  PositionsId.DL,
  // US
  // DS
];
